
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_720_1507)"}},[_c('path',{attrs:{"d":"M30 20H0V0h30v20z","fill":"#ED2939"}}),_c('path',{attrs:{"d":"M20 20H0V0h20v20z","fill":"#fff"}}),_c('path',{attrs:{"d":"M10 20H0V0h10v20z","fill":"#008C45"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_720_1507"}},[_c('rect',{attrs:{"width":"30","height":"20","rx":"3","transform":"matrix(1 0 0 -1 0 20)","fill":"#fff"}})])])])
          )
        }
      }
    